export default __webpack_public_path__ + "static/media/TeacherCirclesOptimized.e831eaf2.webp";